import Button, { BUTTON_TYPES } from '../../Button';
import { FaTimes } from "react-icons/fa";
import Modal from 'react-modal';

const AdminSettingsEditModal = ({ modalTitle, content, isOpen, onClose, handleConfirm }) => {
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            className="custom-modal-content"
            overlayClassName="custom-modal-overlay"
        >
            <div className="d-flex flex-row justify-content-between align-items-center mb-3">
                <h2 className="text-start mb-0">{modalTitle}</h2>
                <button className="close-btn" onClick={onClose}>
                    <FaTimes />
                </button>
            </div>

            <div className='d-flex flex-column' style={{width: '50%', margin: '3em auto'}}>
                {content}
            </div>

            <div className="d-flex flex-row justify-content-center align-items-center two-button-container">
                <Button
                    id="cancel-button"
                    type={BUTTON_TYPES.outline}
                    buttonText="Cancel"
                    action={onClose}
                />
                <div style={{width: '0.5em'}} />
                <Button
                    id="confirm-button"
                    type={BUTTON_TYPES.primary}
                    buttonText="Confirm"
                    action={handleConfirm}
                />
            </div>
        </Modal>
    )
};

export default AdminSettingsEditModal;